import { RefObject, useEffect } from "react";

/**
 * Hook that runs onClickOutside when user clicks outside of ref/refs
 * @param ref one single ref or array of refs to use in determining if the handler should be triggered
 * @param onClickOutside
 * @param depList list with optional dependencies
 */
export function useClickOutside(
  ref: RefObject<HTMLElement | null> | RefObject<HTMLElement | null>[],
  onClickOutside: () => void,
  depList?: unknown[]
) {
  useEffect(
    () => {
      function handleClickOutside(event) {
        const refArray = Array.isArray(ref) ? ref : [ref];
        if (refArray.some((refItem) => refItem.current && refItem.current.contains(event.target))) {
          return;
        }

        onClickOutside();
      }

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    depList ? [ref, ...depList] : [ref]
  );
}
